// evalutionState.ts

import { useContext, useEffect, useState } from 'react';
import { useAptorApi } from '../../../../../Api/useAptorApi';
import { AptorApi } from '../../../../../Api';
import { FormValues } from '../../../../../Components/Form/Form.types';
import { UserContext } from '../../../../../Context/UserContext/UserContext';

export const useEvaluationCardState = () => {
  const { api, abortController } = useAptorApi();
  const { customerId } = useContext(UserContext);
  const [data, setData] = useState<any>(null);
  const [editingData, setEditingData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [editMode, setEditMode] = useState<boolean>(false);
  const [submitting, setSubmitting] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    api
      .getevaluationSettings()
      .then((result) => {
        if (abortController.current.signal.aborted) return;
        setData(result);
      })
      .catch((err) => {
        console.error('API error:', err);
        setData(undefined);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [customerId]);

  const submit = async (
    form: FormValues,
    aptorApi: AptorApi,
    onSuccess: (successMessage?: string | null) => void,
    formatMessage: (descriptor: { id: string; defaultMessage: string }) => string,
  ) => {
    setSubmitting(true);
    const payload = {
      evaluationInformationSv: typeof form.EvaluationInformationSv === 'string' ? form.EvaluationInformationSv : null,
      evaluationInformationEn: typeof form.EvaluationInformationEn === 'string' ? form.EvaluationInformationEn : null,
    };
    aptorApi
      .addevaluationSetting(payload)
      .then(() => {
        if (aptorApi.abortController?.signal.aborted) return;
        setData(payload);
        setEditingData(null);
        onSuccess(
          formatMessage({
            id: 'admin.law-portal.settings.evaluationInformation.updateSuccess',
            defaultMessage: 'Evaluation information updated successfully',
          }),
        );
      })
      .catch(() => {
        onSuccess(
          formatMessage({
            id: 'admin.law-portal.settings.evaluationInformation.updateError',
            defaultMessage: 'Failed to update evaluation information',
          }),
        );
      })
      .finally(() => {
        setSubmitting(false);
        setEditMode(false);
      });
  };

  const startEdit = () => {
    setEditingData(data); // ✅ current data copy karo
    setEditMode(true);
  };

  const cancelEdit = () => {
    setEditingData(null);
    setEditMode(false);
  };

  return { data, editingData, loading, editMode, submitting, submit, startEdit, cancelEdit };
};